export default __webpack_public_path__ + "static/media/swap-key.8c73ff6e.svg";